const ContribVisualiser = require("./../Core/Simulator/contrib_prevusualize");

$(document).ready(function() {
    $('.enterprise-visualise-cdp-contrib-pdf').on('click', function () {
        let $form = $('form[name=app_user_registration]');
        let itemId = $(this).data('item-id');
        ContribVisualiser.visualiseCdpContribPdf($form, 'enterprise_visualise_cdp_contrib_pdf', itemId);
    });

    if ($('#confirmModal').length > 0) {
        let formValidate = $('form[name*=app_user_registration]');
        formValidate.on('submit', function (e) {
            e.preventDefault(); // Bloque la soumission normale
            $('#confirmModal').modal('show');
            // Bouton "Retour"
            $('#modal-back').off('click').on('click', function () {
                $('#confirmModal').modal('hide');
            });
            // Bouton "Confirmer"
            $('#modal-confirm').off('click').on('click', function () {
                $('#confirmModal').modal('hide');
                // Soumission native (évite les doubles submit)
                formValidate[0].submit();
            });
        })
        $('.marypopin-close').on('click', function () {
            $('#confirmModal').modal('hide');
        });
    }
});